import React from "react";
import { ICompareServiceProps } from "../compareService.props";
import {CustomHideScrollBar} from "./compareServiceTable.styled"
export const CompareServiceTable: React.FC<ICompareServiceProps> = (
    {
        refComp,
        onScroll,
        secondService,
        comFirmPracticeLevel,
        inforFirms,
        ...props
    }: ICompareServiceProps
) => {
    const genByLevel = (level?: number) => {
        const maxLevel = 4;
        let rsComp = [];
        rsComp.push(<li className={`w-[15px] h-[7px]  bg-[#CCCCCC]`}></li>)

        if (level) {
            rsComp.splice(0, rsComp.length);

            for (let i = 1; i <= maxLevel; i++) {
                let classColor = "bg-[#EAEAEA]"

                const rsOpacity = {
                    1: "bg-opacity-40",
                    2: "bg-opacity-60",
                    3: "bg-opacity-80",
                    4: "bg-opacity-100",
                }[4]

                if (i <= level) {
                    classColor = `bg-[#2C76AA] ${rsOpacity}`
                }

                rsComp.push(<li className={`w-[10px] h-[6px] ${classColor}`}></li>)
            }
        }

        return <ul className="flex flex-row space-x-[3px] m-0 p-0">
            {rsComp}
        </ul>
    }

    const mappingLevel = (practiceLevel: number) => {
        return {
            1: genByLevel(4),
            2: genByLevel(3),
            3: genByLevel(2),
            4: genByLevel(1),
            0: genByLevel(0)
        }[practiceLevel]
    }

    const createComGenSecondService = () => {
        if (!secondService) {
            return null;
        }
        let rsCom: JSX.Element[] = []

        secondService.forEach(elSecondService => {
            rsCom.push(
                <div className="h-[44px] max-h-[44px] mobile2:h-[80px] flex flex-row  items-center w-full">
                    {/* w-min */}
                    {
                        inforFirms && inforFirms.map((elInfoFirm, index) => {
                            const level = comFirmPracticeLevel ? comFirmPracticeLevel.find(e => e.fkSecondaryServiceId === elSecondService.secondServiceId && e.fkComOffering?.fkOrgId === elInfoFirm.firmID)?.fkPracticeLevelId : 0

                            return (
                                <div key={`${elSecondService.secondServiceId}_${index}`} className="min-w-[94px] w-full h-full flex  justify-center items-center border-b-[1px]  border-r-[1px] border-solid border-[#EAEAEA] ">
                                    <div className=" w-[94px] p-[5px] flex  justify-center items-center">
                                        {
                                            mappingLevel(level ?? 0)
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        });

        return rsCom;
    }

    return secondService && secondService.length ? <div className="bg-white rounded-[10px] mb-[10px] flex flex-row mobile2:rounded-none">
        <div className="flex flex-col border-r-[1px] border-solid border-[#EAEAEA]">
            {
                secondService &&
                secondService.map((e,index) => (
                    <div key={index} className="flex flex-row justify-center items-center mobile2:h-[80px]  h-[44px] max-h-[44px] border-b-[1px] border-solid border-[#EAEAEA] w-[300px] mobile2:w-[179px] px-[30px] py-[10px] mobile2:px-[10px] mobile2:py-[15px]">
                        <p title={`${e.secondServiceName}`} className="w-full line-clamp-1 mobile2:line-clamp-2 mobile2:text-[0.8125rem] mobile2:text-[#000]">
                            {
                                e.secondServiceName
                            }
                        </p>
                    </div>
                ))
            }
        </div>

        <CustomHideScrollBar ref={refComp} onScroll={() => onScroll()} className="flex-1 flex flex-col overflow-x-auto">
            {
                secondService && createComGenSecondService()
            }
        </CustomHideScrollBar>
    </div> : null
}

export default React.memo(CompareServiceTable);